import { memo, type ReactNode } from "react";
import { RESEND_OTP_TIMEOUT_SEC } from "consts/auth";
import { TimeoutableAction } from "ui/widgets/Action";
import useResendLink from "./useResensLlink";

type Props = {
    readonly resendCodeTimeout?: number;
    readonly email: string; 
};

const ResendVerificationLink = ({ resendCodeTimeout = RESEND_OTP_TIMEOUT_SEC, email }: Props) => {
    const { resendLink } = useResendLink();

    const renderChildren = (currentTimeout?: number): [ReactNode, ReactNode] => [
        'Resend link',
        `Resend link in ${currentTimeout} seconds`
    ];


    const handleResendLink = () => resendLink({ email });

    return (
        <TimeoutableAction
            cookieKey='resendResetLinkWithin'
            timeoutSec={resendCodeTimeout}
            request={handleResendLink}
            render={renderChildren}
            ActionProps={{
                sx:{
                    display: 'flex',
                    justifySelf: 'center'
                }
            }}
        />
    );
};

export default memo(ResendVerificationLink);
